export default "__VITE_ASSET__DhV8ZeT$__"